module.exports = "/fonts/eppt-logotype-d-f9028f565a59dde922061c891ca5947e.svg";